"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "a",
      d: "M0 0h145v152H0z"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(38 24)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
      id: "b",
      fill: "#fff",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        href: "#a"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#59285F",
      d: "M3 84v13.864h19.117V152H36.88V97.864H56V84H3",
      mask: "url(#b)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#AE243F",
      d: "M38 55.482L17.503 7.796C14.595 1.029 6.691-1.961.207 1.362L0 1.47l19.236 44.753c3.045 7.085 10.563 11.032 17.997 9.418.255-.056.51-.11.767-.159",
      mask: "url(#b)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#33A79B",
      d: "M71.13 65l28.694-42.773c4.114-6.132 2.223-14.488-4.227-18.158L95.477 4 68.825 43.731a16.61 16.61 0 0 0 2.208 21.173l.098.096",
      mask: "url(#b)"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#59285F",
      d: "M81 98h51.178c7.337.007 13.255-6.298 12.797-13.834l-.008-.166H97.428c-7.983-.008-14.856 5.774-16.403 13.835L81 98",
      mask: "url(#b)"
    })]
  })]
}), '0 0 200 200');